var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMouseInteract = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 51,
    viewBox: "0 0 32 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.405 50C8.079 50 1.328 43.25 1.328 34.923v-24.5A9.422 9.422 0 0 1 10.751 1H22.06a9.422 9.422 0 0 1 9.423 9.423v24.5C31.482 43.25 24.732 50 16.405 50Z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.842 3.513 8.868 1h7.538v13.077a2 2 0 0 1-2 2H1l.33-6.91 2.512-5.654Z",
    fill: "#fff"
  })));
};
export { SvgMouseInteract as ReactComponent };